import { motion } from "motion/react"

interface StatsProps {
  years: number
}

const STATS = (years: number) => [
  { value: `${years}+`, label: "Années d'expérience" },
  { value: "Équipe", label: "Agile & réactive" },
  { value: "100%", label: "Disponible" },
  { value: "<24h", label: "De réactivité" },
]

export default function Stats({ years }: StatsProps) {
  return (
    <section className="py-20 bg-[#06060f] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {STATS(years).map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="text-4xl sm:text-5xl font-bold text-white mb-2 bg-gradient-to-b from-white to-slate-400 bg-clip-text text-transparent">
                {stat.value}
              </div>
              <div className="text-sm text-slate-500">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
